if (!customElements.get('facet-sort-select')) {
  customElements.define(
    'facet-sort-select',
    class FacetSortSelect extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector('.facet-sort-select__trigger');
        this.list = this.querySelector('.facet-sort-select__list');
        this.select = this.querySelector('select[name="sort_by"]');
        this.label = this.querySelector('.facet-sort-select__label');
        this.options = this.querySelectorAll('.facet-sort-select__option');

        this.trigger.addEventListener('click', this.onTriggerClick.bind(this));
        this.options.forEach((option) => option.addEventListener('click', this.onOptionClick.bind(this)));
        this.onDocumentClick = this.onDocumentClick.bind(this);
        document.addEventListener('click', this.onDocumentClick);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
      }

      onTriggerClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const isOpen = this.trigger.getAttribute('aria-expanded') === 'true';
        this.setOpen(!isOpen);
      }

      onOptionClick(event) {
        const option = event.currentTarget;
        const value = option.dataset.value;
        const label = option.textContent.trim();

        this.select.value = value;
        this.label.textContent = label;
        this.options.forEach((item) => {
          item.setAttribute('aria-selected', item === option ? 'true' : 'false');
        });
        this.setOpen(false);
        this.select.dispatchEvent(new Event('input', { bubbles: true }));
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) {
          this.setOpen(false);
        }
      }

      setOpen(open) {
        this.trigger.setAttribute('aria-expanded', open);
        this.list.hidden = !open;
      }
    }
  );
}
